export default "__VITE_ASSET__D7x0XrJ9__"